import React, { useState } from 'react';
import { Tabs } from 'antd';
import { UserOutlined, TeamOutlined, SafetyOutlined, SettingOutlined } from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import feature components
import UsersTab from './components/UsersTab';
import RolesTab from './components/RolesTab';
import PermissionsTab from './components/PermissionsTab';

const UserManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('users');

  const tabItems = [
    {
      key: 'users',
      label: (
        <span>
          <UserOutlined />
          Users
        </span>
      ),
      children: <UsersTab />,
    },
    {
      key: 'roles',
      label: (
        <span>
          <TeamOutlined />
          Roles
        </span>
      ),
      children: <RolesTab />,
    },
    {
      key: 'permissions',
      label: (
        <span>
          <SafetyOutlined />
          Permissions
        </span>
      ),
      children: <PermissionsTab />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<SettingOutlined />}
        title="User Management"
        subtitle="Manage user accounts, roles, and permissions for the fitness management system"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default UserManagement; 